var PromotionStatus = /* @__PURE__ */ ((PromotionStatus2) => {
  PromotionStatus2[PromotionStatus2["SELECTED"] = 0] = "SELECTED";
  PromotionStatus2[PromotionStatus2["UNSELECTED"] = 1] = "UNSELECTED";
  PromotionStatus2[PromotionStatus2["DISABLED"] = 2] = "DISABLED";
  PromotionStatus2[PromotionStatus2["FIXED"] = 3] = "FIXED";
  return PromotionStatus2;
})(PromotionStatus || {});

export { PromotionStatus };
